module.exports = __webpack_public_path__ + "static/media/blob-1.7d55f9d6.svg";